import { __decorate, __metadata } from "tslib";
import { DiningOptionEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsEnum, IsOptional, IsString, MaxLength, ValidateNested } from 'class-validator';
import { SpecialDayTypeEnum, StoreExposeGroup } from '../interface';
import { StoreDateRangeDto } from './StoreDateRangeDto';
export class AbstractStoreSpecialDayDto {
}
__decorate([
    ApiProperty({ enum: SpecialDayTypeEnum }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsEnum(SpecialDayTypeEnum, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], AbstractStoreSpecialDayDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => StoreDateRangeDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreDateRangeDto),
    __metadata("design:type", StoreDateRangeDto)
], AbstractStoreSpecialDayDto.prototype, "range", void 0);
__decorate([
    ApiProperty({ enum: DiningOptionEnum, isArray: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsEnum(DiningOptionEnum, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH], each: true }),
    __metadata("design:type", Array)
], AbstractStoreSpecialDayDto.prototype, "diningOptions", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'Fast Food Festival (FFF)' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.UPDATE] }),
    IsString({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.UPDATE] }),
    MaxLength(255, { groups: [StoreExposeGroup.PATCH, StoreExposeGroup.UPDATE] }),
    __metadata("design:type", String)
], AbstractStoreSpecialDayDto.prototype, "commentForCustomer", void 0);
//# sourceMappingURL=AbstractStoreSpecialDayDto.js.map